import { useState, useCallback } from 'react';
import axios from 'src/utils/axios';

export const useFetch = () => {
  const [state, setState] = useState({ loading: false });

  const fetch = useCallback(async (url, config = {}, setPage) => {
    let responseError = undefined;
    let responseData;
    let responseHeaders;
    try {
      setState((prevState) => ({
        ...prevState,
        error: undefined,
        loading: true,
      }));
      const response = await axios({
        url,
        method: config.method ?? 'GET',
        ...config,
      });
      responseData = response.data;
      responseHeaders = response.headers;
      if (setPage) {
        setPage(0);
      }
      return response;
    } catch (error) {
      responseError = error;
      throw error;
    } finally {
      setState((prevState) => ({
        ...prevState,
        loading: false,
        error: responseError,
        data: responseData,
        headers: responseHeaders,
      }));
    }
  }, []);

  return {
    ...state,
    fetch,
  };
};
